<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <div>
          <img
            width="180"
            style="margin-bottom: 20px"
            src="@/assets/images/logo_white.png"
            alt="Logo Image"
          />

          <div>
            mondayless.inc@gmail.com<br />
            010-5274-6736
          </div>
        </div>
        <p>
          주식회사 먼데이리스<br />
          <br />
          사업자등록번호 : 395-88-01808<br />
          법인등록번호 : 131111-0611870<br />
          경기도 성남시 분당구 판교역로 192번길 16, 8층 86호 에이552
        </p>
      </div>
    </div>
  </section>
</template>
    
  <script>
export default {
  components: {},
  data() {
    return {};
  },
};
</script>
    
  <style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 269px;
  position: relative;
  overflow: hidden;
  background-color: #455463;
}

.content {
  width: 100%;
  max-width: 1140px;
  justify-content: space-between;
  display: flex;
  align-items: flex-start;
  padding-top: 70px;
  color: #dee2e6;
  font-size: 14px;
  font-weight: 200;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 339px;
    position: relative;
    overflow: hidden;
    background-color: #455463;
  }

  .content {
    text-align: center;
    width: 100%;
    display: block;
    padding-top: 70px;
    color: #dee2e6;
    font-size: 14px;
    font-weight: 200;
  }
}
</style>
    